import { Reveal, Kicker } from "@/components/Reveal";
import { IMAGES } from "@/content";

export const EventSection = ({ t }) => (
  <section id="event" data-testid="event-section" className="relative py-24 sm:py-32 px-6">
    <div className="max-w-6xl mx-auto">
      <Reveal>
        <Kicker>{t.event.kicker}</Kicker>
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F4F0E6] max-w-3xl">
          {t.event.title}
        </h2>
      </Reveal>

      <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 mt-16 items-center">
        <Reveal delay={0.15}>
          <div className="relative overflow-hidden rounded-sm border border-[#F4F0E6]/10">
            <img src={IMAGES.event} alt="The Calanchi at night, veiled in amber haze" className="w-full h-[420px] object-cover hover:scale-105 transition-transform duration-[2s]" />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0D0B0A]/90 to-transparent p-6">
              <p className="text-xs tracking-[0.3em] uppercase text-[#8F9779]">{t.event.headlinerLabel}</p>
              <p data-testid="event-headliner" className="font-heading text-4xl sm:text-5xl text-[#D4A373] mt-1">
                {t.event.headliner}
              </p>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal delay={0.2}>
            <p className="text-base sm:text-lg text-[#A8A294] leading-relaxed">{t.event.headlinerDesc}</p>
          </Reveal>
          <div className="mt-10 space-y-0">
            {t.event.items.map((item, i) => (
              <Reveal key={item.label} delay={0.25 + i * 0.08}>
                <div className="flex gap-6 py-5 border-t border-[#F4F0E6]/10" data-testid={`event-item-${i}`}>
                  <span className="w-28 shrink-0 text-xs tracking-[0.2em] uppercase text-[#8F9779] pt-1">{item.label}</span>
                  <span className="text-sm sm:text-base text-[#F4F0E6]">{item.value}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
